import { formatReportNumber } from '../../../../../../features/formatters'

export const getOptions = (legendContainerId, currencySymbol, isScrollable = false, isExporting = false) => {
  return {
    // During export, disable aspect ratio to prevent chart from growing taller when width increases
    // In normal scrollable mode, also disable to allow custom width without affecting height
    maintainAspectRatio: !isScrollable && !isExporting,
    scales: {
      x: {
        stacked: true,
        ticks: {
          display: true,
          color: '#000',
          font: {
            size: 17,
            weight: 400
          }
        },
        grid: {
          display: false
        },
        border: {
          dash: [6, 6],
          display: true,
          color: '#000'
        }
      },
      y: {
        stacked: true,
        ticks: {
          display: true,
          color: '#000',
          font: {
            size: 12,
            weight: 400
          },
          callback: function (value) {
            return Math.round(value).toLocaleString()
          }
        },
        grid: {
          drawBorder: false,
          drawOnChartArea: true,
          dash: [6, 6]
        },
        border: {
          display: false,
          dash: [6, 6]
        }
      }
    },

    plugins: {
      legend: { display: false },
      htmlLegend: {
        containerID: legendContainerId
      },
      tooltip: {
        callbacks: {
          label: tooltipItem =>
            formatReportNumber({ value: tooltipItem.raw, format: 'currency', currency: currencySymbol })
        }
      }
    }
  }
}
